import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Lookup } from "@eres/ejari-api/Entity";
import { TenantContractContext, updateTenantContractContext } from "@eres/ejari-core/contexts/TenantContractContext";
import { populateLookupOnTo } from "@eres/ejari-api/Utils";
import { EjariLookUp } from "@eres/ejari-api/constants";
import { TenancyContactAction } from "@eres/ejari-core/constants";
import Strings from "@my-dld/assets/strings";
import FormRow from "@eres/forms-web/FormRow";
import FormAction from "@my-dld/components/Form/FormAction";
import { navigate } from "@my-dld/utils/StoreUtils";
import { HazardsLookupCache, HazardsState, RenderHazardMaterials } from "../Contract/HazardsInfo";

interface Props extends RoutedViewProps {

}

class HazardsInfo extends Component<Props, HazardsState> {
	static contextType = TenantContractContext;
	context!: React.ContextType<typeof TenantContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			loadState: "loading",
			hazardousMaterials: [],
			selectedIDs: [],
		};
	}

	componentDidMount() {
		const state: Partial<HazardsState> = {};
		const { hazardIds, contract } = this.context;
		if ( hazardIds && hazardIds.length > 0 ) {
			state.selectedIDs = hazardIds ?? [];
		} else if ( contract ) {
			state.selectedIDs = contract.HazardousMaterialClassRels;
		}
		if ( HazardsLookupCache.hazardousMaterials == null || HazardsLookupCache.hazardousMaterials.length == 0 ) {
			populateLookupOnTo( EjariLookUp.HAZARDS_MAT_CLASSIFICATION, {
				onLookup: ( lookup: EjariLookUp | string, values: Lookup[] ) => {
					HazardsLookupCache.hazardousMaterials = values;
					state.hazardousMaterials = values;
					state.loadState = "done";
					this.setState( state as HazardsState );
				}
			} );
		} else {
			state.hazardousMaterials = HazardsLookupCache.hazardousMaterials;
			state.loadState = "done";
			this.setState( state as HazardsState );
		}
	}

	render() {
		const { action } = this.context;
		const { loadState, hazardousMaterials, selectedIDs } = this.state;
		return <>
			<RenderHazardMaterials state={ this.state } onClick={ this.onClick }/>
			<FormRow>
				{ action === TenancyContactAction.UPDATE_CONTRACT ?
					<FormAction
						disablePrimaryAction={ selectedIDs.length === 0 }
						groupClassName={ "text-center" }
						primaryActionLabel={ Strings.save }
						onPrimaryAction={ this.onSave }
						secondaryActionLabel={ Strings.back }
						onSecondaryAction={ this.onBack }/> :
					<FormAction
						disablePrimaryAction={ selectedIDs.length === 0 }
						groupClassName={ "text-center" }
						primaryActionLabel={ Strings.continue }
						onPrimaryAction={ this.onContinue }
						secondaryActionLabel={ Strings.back }
						onSecondaryAction={ this.onBack }/> }
			</FormRow>
		</>;
	}

	private onClick = ( hazard: Lookup, isSelected: boolean ) => {
		const { selectedIDs } = this.state;
		if ( isSelected ) {
			this.setState( {
				selectedIDs: selectedIDs.filter( id => id !== hazard.Id ),
			} );
		} else {
			this.setState( {
				selectedIDs: [ ...selectedIDs, hazard.Id ],
			} );
		}
	};

	private onContinue = () => {
		updateTenantContractContext( {
			hazardIds: this.state.selectedIDs,
		} );
		navigate( "documents" );
	};

	private onSave = () => {
		const { selectedIDs } = this.state;
		let { contract } = this.context;
		contract = {
			...contract,
			HazardousMaterialClassRels: selectedIDs,
		};
		updateTenantContractContext( { contract: contract, hazardIds: selectedIDs, canResubmit: true } );
		this.onBack();
	};

	private onBack = () => {
		this.props.history.goBack();
	};
}

export default HazardsInfo;
